import { platformStorage } from '../../utils/storage';
import { api } from './client';

export const zoneApi = {
  getZones: async (orgId: string, siteId?: string) => {
    const response = await api.get(`/zones/org/${orgId}`);
    let zones = response.data;

    if (siteId) {
      zones = zones.filter((zone: any) => zone.siteId === siteId);
    }

    return zones;
  },

  getAll: async () => {
    const user = await platformStorage.getItem('user_data');
    if (!user) {
      throw new Error('User not found');
    }
    const userData = typeof user === 'string' ? JSON.parse(user) : user;
    const orgId = userData.orgId;
    return zoneApi.getZones(orgId);
  },

  getById: async (zoneId: string) => {
    const response = await api.get(`/zones/${zoneId}`);
    return response.data;
  },

  createZone: async (data: any) => {
    const response = await api.post('/zones', data);
    return response.data;
  },

  updateZone: async (zoneId: string, data: any) => {
    const response = await api.patch(`/zones/${zoneId}`, data);
    return response.data;
  },

  deleteZone: async (zoneId: string) => {
    const response = await api.delete(`/zones/${zoneId}`);
    return response.data;
  },

  getZonePermissions: async (zoneId: string) => {
    const response = await api.get(`/zones/${zoneId}/permissions`);
    return response.data;
  },

  addZonePermission: async (zoneId: string, data: { userId: string; permissionLevel?: string }) => {
    const response = await api.post(`/zones/${zoneId}/permissions`, data);
    return response.data;
  },

  updateZonePermission: async (
    zoneId: string,
    permissionId: string,
    data: { permissionLevel: string },
  ) => {
    const response = await api.patch(`/zones/${zoneId}/permissions/${permissionId}`, data);
    return response.data;
  },

  removeZonePermission: async (zoneId: string, permissionId: string) => {
    const response = await api.delete(`/zones/${zoneId}/permissions/${permissionId}`);
    return response.data;
  },
};
